module.exports = __webpack_public_path__ + "img/trashcan.171e893d.svg";